import { getSharingEnvironment } from '@squaredup/open-access';
import { useTenant } from './useTenant';

export const useAuthenticatedDomains = () => {
    const tenant = useTenant();
    const sharingEnv = getSharingEnvironment(tenant.data);

    return sharingEnv.tenantSharingSettings.authenticatedDomains;
};
